import _sfc_main from './UiName.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("span", { staticClass: "fds-ui-name", attrs: { "title": _setup.title } }, [_vm._t("root", function() {
    return [_setup.hasLinkClickListener ? _c("a", { staticClass: "fds-ui-link", attrs: { "tabindex": "0", "role": "link" }, on: { "keyup": function($event) {
      if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
        return null;
      $event.stopPropagation();
      return _setup.onLinkClick.apply(null, arguments);
    }, "click": function($event) {
      $event.stopPropagation();
      return _setup.onLinkClick.apply(null, arguments);
    } } }, [_vm._v(" " + _vm._s(_vm.name) + " ")]) : [_vm._v(" " + _vm._s(_vm.name) + " ")]];
  }, null, { name: _vm.name, onLinkClick: _setup.onLinkClick })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/ui-name/UiName.vue";
var UiName = __component__.exports;

export { UiName as default };
